/* eslint-disable prettier/prettier */

import { ActiveCollateralAssets } from '~config/protocol';
import { EVestaAsset } from '~config/types';

import { IntermediatePoolComputed, VaultQuery } from '../_types';
import { useIndexedQueries } from '../useIndexedQueries';

import { useVaultData } from './useVaultData';

export interface SysVaultComputed {
  totalCollateralUsd: number;
  totalSystemDebtUsd: number;
  totalSystemDebtVst: number;
  isAnyVaultLoading: boolean;
}

export function onArrayVaultDataReducer<IndexType, QueryDataType>(
  data: IntermediatePoolComputed<QueryDataType, IndexType>[],
  dataMapCallback: (
    data: IntermediatePoolComputed<QueryDataType, IndexType>,
    index: number,
  ) => SysVaultComputed,
) {
  return data.map(dataMapCallback).reduce(
    (prev, cur) => ({
      totalCollateralUsd: prev.totalCollateralUsd + cur.totalCollateralUsd,
      totalSystemDebtUsd: prev.totalSystemDebtUsd + cur.totalSystemDebtUsd,
      totalSystemDebtVst: prev.totalSystemDebtVst + cur.totalSystemDebtVst,
      isAnyVaultLoading: prev.isAnyVaultLoading ? true : cur.isAnyVaultLoading,
    }),
    {
      totalCollateralUsd: 0,
      totalSystemDebtUsd: 0,
      totalSystemDebtVst: 0,
      isAnyVaultLoading: false,
    } as SysVaultComputed,
  );
}

export const useAllVaultData = () => {
  const allVaults = useIndexedQueries<EVestaAsset, VaultQuery, SysVaultComputed>({
    hook: useVaultData,
    indexValues: ActiveCollateralAssets,
    onArray: data =>
      onArrayVaultDataReducer(data, vault => ({
        totalCollateralUsd: vault.data.data.computed.totalCollateralUsd ?? 0,
        totalSystemDebtUsd: vault.data.data.computed.totalDebtUsd ?? 0,
        totalSystemDebtVst: Number(vault.data.data.vault.currentAssetSystemState.totalDebt ?? '0'),
        isAnyVaultLoading: vault.data.isLoading,
      })),
  });

  return allVaults;
};
